import type { DoctorSpeciality } from '~/api/generated';

export const useDignitiesStore = defineStore('dignities', {
  state: () => ({
    loading: false,
    dignities: [] as DoctorSpeciality[]
  }),
  actions: {
    async getDignities() {
      const apiStore = useApiStore();

      this.loading = true;

      try {
        const dignities = await apiStore.api.tardocDoctorSpecialities.tardocDoctorSpecialityList();

        if (dignities) {
          this.dignities = dignities;
        }
      } finally {
        this.loading = false;
      }
    }
  },
  persist: {
    storage: persistedState.localStorage,
    omit: ['loading']
  }
});
